import { Component } from 'react';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    logRavenException(error, 'ErrorBoundary', info);
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return /*#__PURE__*/_jsx(this.props.HasErrorComponent, {});
    }
    return this.props.children;
  }
}